"use client";

import { c as _c } from "react/compiler-runtime";
import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
export function Toaster() {
  const $ = _c(8);
  const {
    toasts
  } = useToast();
  const isMobile = useIsMobile();
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!mounted) {
    return null;
  }
  const t2 = isMobile ? "down" : "right";
  let t3;
  if ($[2] !== toasts) {
    t3 = toasts.map(_temp);
    $[2] = toasts;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ToastViewport />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t3) {
    t5 = createPortal(<ToastProvider swipeDirection={t2}>{t3}{t4}</ToastProvider>, document.body);
    $[5] = t2;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp(t0) {
  const {
    id,
    title,
    description,
    action,
    variant,
    ...props
  } = t0;
  return <Toast key={id} variant={variant} {...props}><div className="grid min-w-0">{title && <ToastTitle className={cn(variant === "minimal" && "text-xs")}>{title}</ToastTitle>}{description && <ToastDescription>{description}</ToastDescription>}</div>{action}<ToastClose /></Toast>;
}